import React from 'react';

const IntellectualProperty = () => {
  return (
    <div style={{
      maxWidth: '900px', margin: '80px auto', padding: '0 20px',
      color: '#e6eefb', lineHeight: 1.7
    }}>
      <h2 style={{ marginBottom: '12px' }}>Propiedad Intelectual</h2>
      <p>En construcción.</p>
    </div>
  );
};

export default IntellectualProperty;


